import { UISnackBarService } from 'app/ui/snack-bar/snack-bar.service';
import { ServiceType } from 'app/core/service-type.model';
import { ApplicationCloneStatus } from './../application.model';
import {
  Component,
  Input,
  OnInit,
  HostBinding,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter
} from '@angular/core';

import { Application } from '../application.model';
import { DeleteApplicationComponent } from '../delete-application/delete-application.component';
import { RestoreTokenComponent } from '../restore-token/restore-token.component';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { ApplicationsService } from '../applications.service';

@Component({
  selector: 'application',
  templateUrl: 'application.component.html',
  styleUrls: ['application.component.scss']
})
export class ApplicationComponent implements OnInit {
  @ViewChild('duplicated')
  private _duplicatedTemplate: TemplateRef<any>;

  @Input()
  application: Application;

  @Input()
  showActiveApp: boolean;

  @Input()
  applicationsCount: number;

  applicationName: string;

  applicationCloneStatus = ApplicationCloneStatus;

  @HostBinding('class.copying-app')
  isCopyingApp;

  @HostBinding('class.editing')
  isEditing = false;
  isSaving = false;
  isTokenVisible = false;
  isTokenLoading = false;

  @Input()
  serviceType: ServiceType;

  isVisibleDetails: boolean = false;

  constructor(
    private applicationsService: ApplicationsService,
    private dialogService: UIDialogService,
    private _snackBarService: UISnackBarService
  ) { }

  ngOnInit() {
    this.applicationName = this.application.name;
    this.isCopyingApp = this.showCloningStatus();
    this.isVisibleDetails = this.applicationsCount > 1 ? false : true;
  }

  getTooltipApplicationDemoText(): string {
    return `<span>Learn more about this FlexiCapture Demo Project</span>
    <div class='cell--link-project-svg-content'>
      <a href="${this.getLinkApplicationHelp()}" target="_blank">http://help.abbyy.com</a>
      <img src="/assets/icons/go-to-link.svg">
    </div>`;
  }

  getLinkApplicationHelp(): string {
    return this.application
      ? this.application.type === 'dc'
        ? 'http://help.abbyy.com/en-us/flexicapture/12/distributed_administrator/samples'
        : 'http://help.abbyy.com/en-us/flexicapture/12/distributed_administrator/ir_titletopic'
      : null;
  }

  focus(element: HTMLInputElement) {
    setTimeout(() => {
      element.focus();
      element.setSelectionRange(0, 0);
    });
  }

  edit() {
    this.isEditing = true;
  }

  save() {
    this.isSaving = true;
    const subscription = this.applicationsService
      .renameApplication(this.application.id, this.applicationName)
      .subscribe(
        () => {
          this.isEditing = false;
          this.isSaving = false;
          subscription.unsubscribe();
        },
        error => console.error(error)
      );
  }

  copyApp($event) {
    if (!this.canDuplicate()) {
      $event.stopPropagation();
      $event.preventDefault();
      return;
    }

    const subscription = this.applicationsService
      .copyApplication(this.application.id)
      .subscribe(
        () => {
          this._snackBarService.open(this._duplicatedTemplate);
          subscription.unsubscribe();
        },
        error => console.error(error)
      );
  }

  cancel() {
    this.isEditing = false;
  }

  copy(value: string) {
    const copy = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', value);
      e.preventDefault();
      document.removeEventListener('copy', copy, false);
    };

    document.addEventListener('copy', copy, false);
    document.execCommand('copy');
  }

  setDefault() {
    this.applicationsService.setDefault(this.application);
  }

  isDefault() {
    return (
      this.application.id === this.applicationsService.defaultApplication().id
    );
  }

  showToken() {
    this.isTokenVisible = !this.isTokenVisible;
  }

  showCloningView() {
    return this.application.clone && this.application.clone.progress < 100;
  }

  showCloningStatus() {
    const clone = this.application.clone;

    return (
      clone &&
      (clone.status === this.applicationCloneStatus.Added ||
        clone.status === this.applicationCloneStatus.Processing)
    );
  }

  isCloningError() {
    const { clone } = this.application;

    return clone && clone.status === this.applicationCloneStatus.Error ? true : false;
  }

  tokenView(): string {
    if (this.isTokenVisible) {
      return this.application.token;
    }
    return '•'.repeat(49);
  }

  tokenInputType() {
    return this.isTokenVisible ? 'text' : 'password';
  }

  restoreToken() {
    this.dialogService.open(RestoreTokenComponent, { data: this.application });
  }

  delete() {
    if (this.canDelete()) {
      this.dialogService.open(DeleteApplicationComponent, {
        data: this.application
      });
    }
  }

  canDelete() {
    return (
      ((this.application.tenant && this.application.type === 'dc') ||
        this.application.type === 'ic' && this.application.isCustomized) &&
      this.applicationsService.applications().length > 1
    );
  }

  canDuplicate() {
    return this.application.isCustomized && !this.application.clone;
  }

  deleteTooltip() {
    const applications = this.applicationsService.applications();
    if (this.canDelete()) {
      return 'Delete application';
    } else if (applications.length === 1 || !this.application.isCustomized) {
      return 'Demo application can not be deleted';
    } else {
      return 'Last application can not be deleted.'
    }
  }

  duplicateTooltip() {
    if (!this.canDuplicate()) {
      if (!this.application.isCustomized) {
        return 'Demo application can not be duplicated';
      } else if (this.application.clone) {
        return 'Copy of application can not be duplicated';
      }
    }

    return 'Copy application';
  }


  toggleVisibleDetails() {
    if (this.isCloningError()) {
      return;
    }

    this.isVisibleDetails = !this.isVisibleDetails;
  }
}
